<template>
  <div class="cta">
    <figure class="image">
      <picture>
        <source
          media="(max-width: 768px)"
          sizes="(max-width: 1536px) 100vw, 1536px"
          srcset="
            ../assets/images/Blumenwiese-380.jpg     380w,
            ../assets/images/Blumenwiese-380@2x.jpg  760w,
            ../assets/images/Blumenwiese-768.jpg     768w,
            ../assets/images/Blumenwiese-768@2x.jpg 1536w
          "
        />
        <source
          media="(min-width: 769px"
          sizes="(min-width: 769px) 100vw, 3840px"
          srcset="
            ../assets/images/Blumenwiese-1024.jpg    1024w,
            ../assets/images/Blumenwiese-1216.jpg    1216w,
            ../assets/images/Blumenwiese-1407.jpg    1407w,
            ../assets/images/Blumenwiese-1024@2x.jpg 2048w,
            ../assets/images/Blumenwiese-1216@2x.jpg 2432w,
            ../assets/images/Blumenwiese-1407@2x.jpg 2814w,
            ../assets/images/Blumenwiese-1920.jpg    1920w,
            ../assets/images/Blumenwiese-1920@2x.jpg 1921w
          "
        />
        <img
          sizes="(max-width: 7500px) 40vw, 3000px"
          srcset="
            ../assets/images/Blumenwiese-380.jpg      380w,
            ../assets/images/Blumenwiese-380@2x.jpg   760w,
            ../assets/images/Blumenwiese-768.jpg      768w,
            ../assets/images/Blumenwiese-1024.jpg    1024w,
            ../assets/images/Blumenwiese-1216.jpg    1216w,
            ../assets/images/Blumenwiese-1407.jpg    1407w,
            ../assets/images/Blumenwiese-1024@2x.jpg 2048w,
            ../assets/images/Blumenwiese-1216@2x.jpg 2432w,
            ../assets/images/Blumenwiese-1407@2x.jpg 2814w,
            ../assets/images/Blumenwiese-1920.jpg    1920w,
            ../assets/images/Blumenwiese-1920@2x.jpg 1921w
          "
          src="../assets/images/Blumenwiese-1920.jpg"
          alt="Nahaufnahme eine Blumenwiese"
        />
      </picture>
    </figure>
    <div class="hero is-info">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h2 class="title is-2 is-size-3-mobile">{{ title }}</h2>
          <p class="subtitle is-4 is-size-5-mobile">{{ subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cta",
  data() {
    return {
      isLoading: true
    };
  },
  props: {
    subtitle: String,
    title: String
  }
};
</script>

<style lang="scss">
.tmptest {
  height: 200px;
}
</style>
